import {
  Component,
  OnInit,
  Input,
  ElementRef,
  ViewChild,
  AfterViewInit,
  ChangeDetectionStrategy,
} from '@angular/core';
import { ImageSlide } from './models/image-slide';
import { imageSliderAnimations } from './image-slider.animations';
import { Subject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { SpinnerComponent } from '../../spinner/spinner.component';
import { ModalGalleryComponent } from '../modal-gallery/modal-gallery.component';

@Component({
  selector: 'ag-image-slider',
  templateUrl: './image-slider.component.html',
  styleUrls: ['./image-slider.component.scss'],
  animations: [...imageSliderAnimations],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AngularSvgIconModule, SpinnerComponent, ModalGalleryComponent],
})
export class ImageSliderComponent implements OnInit, AfterViewInit {
  @Input() images: Array<ImageSlide> = new Array<ImageSlide>();

  currentImage: any;
  galleryIsOpen = false;
  loadingImage = true;
  currentImageSubject: Subject<ImageSlide> = new Subject();

  @ViewChild('currentImageRef')
  currentImageRef: ElementRef<HTMLImageElement>;

  constructor() {}

  ngOnInit(): void {
    this.currentImageSubject
      .pipe(
        tap((_) => {
          this.loadingImage = true;
        }),
      )
      .subscribe((image) => {
        this.currentImage = image;
      });

    this.currentImageSubject.next(this.images[0]);
  }

  ngAfterViewInit(): void {
    this.currentImageRef.nativeElement.onload = () => {
      this.loadingImage = false;
    };
  }

  showGallery() {
    this.galleryIsOpen = true;
  }

  nextImage() {
    const currentIndex = this.images.findIndex(
      (v) => v.id === this.currentImage.id,
    );
    if (currentIndex + 1 > this.images.length - 1) {
      this.currentImageSubject.next(this.images[0]);
    } else {
      this.currentImageSubject.next(this.images[currentIndex + 1]);
    }
  }

  previousImage() {
    const currentIndex = this.images.findIndex(
      (v) => v.id === this.currentImage.id,
    );
    if (currentIndex - 1 === -1) {
      this.currentImageSubject.next(this.images[this.images.length - 1]);
    } else {
      this.currentImageSubject.next(this.images[currentIndex - 1]);
    }
  }
}
